import { render, staticRenderFns } from "./GoodsListModal.vue?vue&type=template&id=70eb9ba5&scoped=true&"
import script from "./GoodsListModal.vue?vue&type=script&lang=js&"
export * from "./GoodsListModal.vue?vue&type=script&lang=js&"
import style0 from "./GoodsListModal.vue?vue&type=style&index=0&id=70eb9ba5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70eb9ba5",
  null
  
)

export default component.exports